const ccBillingAddessForVerificationReducer = (state = '', action) => {
	switch(action.type){
	case 'CCBILLIGNADDRESSFORVERIFICAIONVALUE':
		return action.payload;
	default:
		return state;
	}
}

export default ccBillingAddessForVerificationReducer;